/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../core/components';
import { Component } from '@angular/core';
import { MenuConfigModel } from '../../../../core/models';
import { RbacService } from '../../../../core/services';

@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html'
})

export class ScheduleComponent extends BaseComponent {
    /**
     * Menu config.
     */
    public menuConfig: MenuConfigModel;

    constructor(
        private rbacService: RbacService,
    ) {
        super();

        this.menuConfig = this.rbacService.getMenuById('scheduler');
    }
}
